import { timeTo, format } from './day';
import { plural } from './pluralize';

export default {
  install(Vue) {
    Vue.filter('timeTo', timeTo);
    Vue.filter('format', format);
    Vue.filter('pluralize', plural);
  },
};
